export default __webpack_public_path__ + "static/media/c4c_955x875.aadbc1cc.jpg";